import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../app.config';
import get from 'lodash.get';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var TranslationsLoader = /** @class */ (function () {
    function TranslationsLoader(http) {
        this.http = http;
        this.initialPageData = JSON.parse(get(document.getElementById('initialPageData'), 'innerHTML') || null);
    }
    TranslationsLoader.prototype.getTranslation = function (lang) {
        if (this.initialPageData && this.initialPageData.localization) {
            return of(this.initialPageData.localization);
        }
        return this.http.get(config.translateApi);
    };
    TranslationsLoader.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TranslationsLoader_Factory() { return new TranslationsLoader(i0.ɵɵinject(i1.HttpClient)); }, token: TranslationsLoader, providedIn: "root" });
    return TranslationsLoader;
}());
export { TranslationsLoader };
